// extracted by mini-css-extract-plugin
export default {"root":"CustomEmojiPicker-module__root","activated":"CustomEmojiPicker-module__activated"};